var _path, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 120,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "empty_svg__c",
    width: 220,
    height: 219,
    x: -30,
    y: -51,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#empty_svg__b)",
    d: "M0 0h218.182v218.182H0z",
    transform: "translate(-29.09 -50.91)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#EAECF0",
    strokeWidth: 0.455,
    clipPath: "url(#empty_svg__d)",
    mask: "url(#empty_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.227-50.909v218.182M14.773-50.909v218.182M29.318-50.909v218.182M43.864-50.909v218.182M58.409-50.909v218.182M72.955-50.909v218.182M87.5-50.909v218.182M102.045-50.909v218.182M116.591-50.909v218.182M131.136-50.909v218.182M145.682-50.909v218.182"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-28.863-50.682h217.727v217.727H-28.863z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-29.091 7.045h218.182M-29.091 21.591h218.182M-29.091 36.136h218.182M-29.091 50.682h218.182M-29.091 65.227h218.182M-29.091 79.773h218.182M-29.091 94.318h218.182M-29.091 108.864h218.182"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-28.863-50.682h217.727v217.727H-28.863z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 58.182,
    r: 58.182,
    fill: "#F2F2F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.909,
    cy: 14.546,
    r: 5.818,
    fill: "#F5F5F5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 91.636,
    r: 4.364,
    fill: "#F5F5F5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.182,
    cy: 100.364,
    r: 7.273,
    fill: "#F5F5F5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.727,
    cy: 33.455,
    r: 7.273,
    fill: "#F5F5F5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.909,
    cy: 8,
    r: 5.091,
    fill: "#F5F5F5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    fillRule: "evenodd",
    d: "M82.535 11.636c-12.172 0-22.939 6.015-29.491 15.234a29 29 0 0 0-6.665-.771c-15.974 0-28.924 12.95-28.924 28.924s12.95 28.925 28.924 28.925h72.312c13.978 0 25.309-11.331 25.309-25.309s-11.331-25.31-25.309-25.31q-1.49.001-2.935.17c-5.541-12.86-18.33-21.863-33.22-21.863",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.379,
    cy: 55.023,
    r: 28.925,
    fill: "url(#empty_svg__h)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.535,
    cy: 47.792,
    r: 36.156,
    fill: "url(#empty_svg__i)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.691,
    cy: 58.639,
    r: 25.309,
    fill: "url(#empty_svg__j)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty_svg__k)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.727,
    height: 40.727,
    x: 59.636,
    y: 61.091,
    fill: "#473838",
    fillOpacity: 0.4,
    rx: 20.364
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M72.982 79.758a5.321 5.321 0 1 1 10.642 0 5.321 5.321 0 0 1-10.642 0m5.32-6.558a6.558 6.558 0 1 0 4.18 11.611l4.293 4.293a.618.618 0 1 0 .874-.874l-4.293-4.293A6.558 6.558 0 0 0 78.303 73.2",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h160v120H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-29.09-50.91H189.09v218.183H-29.09z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-29.091-50.909h218.182v218.182H-29.091z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-29.091-50.909h218.182v218.182H-29.091z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__h",
    x1: 24.169,
    x2: 75.304,
    y1: 35.912,
    y2: 83.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__i",
    x1: 54.773,
    x2: 118.691,
    y1: 23.904,
    y2: 83.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__j",
    x1: 99.257,
    x2: 144,
    y1: 41.917,
    y2: 83.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty_svg__g",
    width: 155.636,
    height: 101.403,
    x: 2.909,
    y: 11.636,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2.909,
    result: "effect1_dropShadow_1740_42924"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.818
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.909
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1740_42924"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 2.909,
    result: "effect2_dropShadow_1740_42924"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.546
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.727
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1740_42924",
    result: "effect2_dropShadow_1740_42924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1740_42924",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty_svg__k",
    width: 52.364,
    height: 52.364,
    x: 53.818,
    y: 55.273,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 2.909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1740_42924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1740_42924",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "empty_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 0 109.091)scale(109.091)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
};
export { SvgEmpty as ReactComponent };
export default __webpack_public_path__ + "fe6e62f8a9b159faf5152fb6a0cc3a7e.svg";